module.exports = __webpack_public_path__ + "img/zeigling4.675baa02.jpg";